import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
	login,
	getUserGroups,
	getCurrentUserProfile,
	setStoredUserClassificationName,
} from "../../utilities/AuthService";
import { registerFcmToken } from "../../utilities/firebaseMessaging";
import PageTitle from "../PageTitle";

const Login = () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const location = useLocation();
	const navigate = useNavigate();

	// Get the intended destination from location state, or default to home
	const from = location.state?.from?.pathname || "/";
	const passwordChangedMessage =
		location.state?.passwordChangedMessage;

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		setError("");

		try {
			const authPayload = await login(username, password);
			// Fetch and store user groups after successful login
			const groups = await getUserGroups();
			localStorage.setItem(
				"user_groups",
				JSON.stringify(groups)
			);
			try {
				const profile = await getCurrentUserProfile();
				setStoredUserClassificationName(
					profile.classification_name ?? "",
				);
			} catch (profileErr) {
				console.error(
					"Could not load user profile:",
					profileErr,
				);
			}
			if (authPayload.must_change_password) {
				navigate("/change-initial-password", { replace: true });
				return;
			}
			registerFcmToken().catch((fcmError) => {
				console.error("FCM token registration failed:", fcmError);
			});
			// Navigate to the intended page or home
			navigate(from, { replace: true });
		} catch (error) {
			console.error("Login failed:", error);

			// Set appropriate error message based on error type
			if (error.response?.status === 401) {
				setError(
					"아이디 또는 비밀번호가 올바르지 않습니다."
				);
			} else if (error.response?.status >= 500) {
				setError(
					"서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요."
				);
			} else if (error.message === "Network Error") {
				setError("네트워크 연결을 확인해주세요.");
			} else {
				setError(
					"로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요."
				);
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="login__container">
			<PageTitle title="로그인" />
			<h1 className="login__title">로그인</h1>
			<form className="login__form" onSubmit={handleSubmit}>
				{passwordChangedMessage && (
					<div
						style={{
							color: "#0a7d2f",
							marginBottom: "12px",
							textAlign: "center",
							fontSize: "14px",
							lineHeight: 1.5,
						}}>
						{passwordChangedMessage}
					</div>
				)}
				<input
					type="text"
					value={username}
					className="login__form__input"
					placeholder="ID"
					onChange={(e) =>
						setUsername(e.target.value)
					}
					disabled={isLoading}
				/>
				<input
					type="password"
					value={password}
					className="login__form__input"
					placeholder="Password"
					onChange={(e) =>
						setPassword(e.target.value)
					}
					disabled={isLoading}
				/>
				{error && (
					<div
						style={{
							color: "red",
							marginBottom: "10px",
							textAlign: "center",
						}}>
						{error}
					</div>
				)}
				<input
					className="login__form__submit"
					type="submit"
					value={
						isLoading
							? "로그인 중..."
							: "로그인"
					}
					disabled={isLoading}
				/>
			</form>
		</div>
	);
};

export default Login;
